import AvailableCampaigns from './AvailableCampaigns';
import './AvailableCampaigns.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

// Action Creators
import {
  requestCoupon,
  setGoalAmount,
} from '../../../../redux/loyalty/actions';

import {
  finishAllCampaignsEvent,
  shareSocialMediaEvent
} from '../../../../redux/mixpanel/actions';

import {
  setDcmPreviewTagRendered
} from '../../../../redux/dcm/actions';

import {
  postCampaignCompletionAnswer,
  rateCampaign
} from '../../../../redux/campaigns/actions';

// Redux
const mapStateToProps = (state) => {
  return {
    campaigns:    state.campaigns,
    cardAmount:   state.loyalty.cardAmount,
    bufferAmount: state.loyalty.bufferAmount,
    goalAmount:   state.loyalty.goalAmount,
    dcm:          state.dcm,
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    // Loyalty
    requestCoupon,
    setGoalAmount,
    // Mixpanel
    finishAllCampaignsEvent,
    shareSocialMediaEvent,
    // DCM
    setDcmPreviewTagRendered,
    // Rate Campaign
    postCampaignCompletionAnswer,
    rateCampaign
  }, dispatch);
}

const ConnectedAvailableCampaigns = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AvailableCampaigns));

export default ConnectedAvailableCampaigns;



// WEBPACK FOOTER //
// ./src/pages/Campaigns/containers/AvailableCampaigns/index.js